var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.providerComponent,{tag:"component",attrs:{"id":_vm.data_item.id},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var item = ref.item;
var loading = ref.loading;
return [_c('div',[(loading)?_c('loading-span',{attrs:{"message":"Loading dataset"}}):_vm._e(),_vm._v(" "),(item)?_c(_vm.renderComponent,{tag:"component",attrs:{"item":item}}):_vm._e()],1)]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }